var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('router-link',{staticClass:"topic",attrs:{"to":`${`/topic/${_vm.getTopicCode}`}`}},[(_vm.showImage)?_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.showImage,"alt":_vm.getName,"onerror":"this.style.display='none'"}})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.getName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }